import { useCallback } from 'react'
import { useDispatch, useSelector } from '@common/oneclub/store'
import { loginout } from '@common/oneclub/store/authSlice'
import { getOneClubPath } from '@common/oneclub/utils'

export function useUserLogout() {
  const dispatch = useDispatch()
  const lang = useSelector((state) => state.language.lang)

  const handleLogout = useCallback(async () => {
    await dispatch(loginout())
    const url = getOneClubPath('/user/login', lang)
    window.location.replace(url)
  }, [dispatch, lang])

  return handleLogout
}
